export default "__VITE_ASSET__RSREamP8__"